module.exports = __webpack_public_path__ + "img/file-add.4313fe9a.svg";